<template>
    <v-row>
        <v-col cols="12" md="6">
            <div v-if="!loading">
                <div v-if="hasLicense">
                    <v-row>
                        <v-col>
                            <v-simple-table dense >
                                <tbody>
                                    <tr>
                                        <th>{{$t("traffic_license_name")}}</th>
                                        <td>{{data.name}}</td>
                                    </tr>
                                    <tr>
                                        <th>{{$t("start_date")}}</th>
                                        <td>{{formatDate(data.start_at)}}</td>
                                    </tr>
                                    <tr>
                                        <th>{{$t("end_date")}}</th>
                                        <td>{{formatDate(data.end_at)}}</td>
                                    </tr>
                                </tbody>
                            </v-simple-table>
                        </v-col>
                    </v-row>
                    <v-row>
                        <v-col>
                            <v-btn small class="me-2" @click="trafficLicenseCreateDialog = true"  v-if="hasPermission(permissions.vehicle_license.create)">
                                <v-icon left>mdi-gesture-tap-button</v-icon>
                                {{$t("license_renew")}}
                            </v-btn>
                        </v-col>
                    </v-row>
                </div>
                <div v-else class="d-flex flex-column align-center">
                    <p class="text-h5">{{$t("traffic_license")}}</p>
                    <v-alert type="warning" text dense>{{$t("no_traffic_license")}}</v-alert>
                    <v-btn small text @click="trafficLicenseCreateDialog = true" v-if="hasPermission(permissions.vehicle_license.create)">
                        <v-icon left>mdi-gesture-tap-button</v-icon>
                        {{$t("traffic_license_add")}}
                    </v-btn>
                </div>
            </div>
            <div v-else>
                <v-row>
                    <v-col>
                        <v-skeleton-loader type="text" class="mb-4"></v-skeleton-loader>
                        <v-skeleton-loader type="text" class="mb-4"></v-skeleton-loader>
                        <v-skeleton-loader type="text" class="mb-4"></v-skeleton-loader>
                        <v-skeleton-loader type="text" class="mb-4"></v-skeleton-loader>
                    </v-col>
                </v-row>
            </div>
        </v-col>
        <v-dialog v-model="trafficLicenseCreateDialog" max-width="500" scrollable persistent>
            <TrafficLicenseCreate
                v-if="trafficLicenseCreateDialog"
                :vehicleId="this.vehicleId"
                @cancel="trafficLicenseCreateDialog = false"
                @created="onTrafficLicenseCreated"
                />
        </v-dialog>
    </v-row>
</template>

<script>
import license from './../../services/license';
import TrafficLicenseCreate from '../../components/fleet/TrafficLicenseCreate.vue';
import moment from 'moment';
import permissions from '../../data/permissions';
import authorize from '../../utils/authorize';

export default {
    components: {
        TrafficLicenseCreate
    },
    data() {
        return {
            trafficLicenseCreateDialog: false,
            loading: false,
            vehicleId: null,
            data: {},
            permissions
        }
    },
    computed: {
        hasLicense() {
            return !!this.data.id
        },
    },
    methods: {
        fetch() {
            this.loading = true;
            license.findByVehicleId(this.vehicleId).then(res => {
                this.data = res.data;
            }).catch(error => {
                if(error.response) {
                    if(error.response.status) {
                        this.data = {}
                    }
                }
            })
            .finally(() => {
                this.loading = false;
            })
        },
        onTrafficLicenseCreated() {
            this.trafficLicenseCreateDialog = false;
            this.fetch();
        },
        formatDate(date) {
            return moment(date).format("YYYY-MM-DD")
        },
        hasPermission(code) {
            return authorize(code)
        }
    },
    created() {
        this.vehicleId = this.$route.params.vehicleID;
        this.fetch();
    }
}
</script>

<style>

</style>